import { Autocomplete, Button, FormHelperText, Grid2, TextField, Typography, useTheme } from '@mui/material';
import { Formik } from 'formik';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dispatch } from 'store';
import { useUpdateDocumentStatusMutation } from 'store/slices/apis/documentsSlice';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';
import * as Yup from 'yup';

const currentStatuses = [
    { label: "Approved without Comment" },
    { label: "Approved with Comment" },
    { label: "Revise & Resubmit" },
    { label: "Rejected" },
];

export default function AddComment(props) {
    const { id } = props;
    const theme = useTheme();
    const navigate = useNavigate();
    const { projectId } = useParams();
    const formikRef = React.useRef();
    const [updateWorkFlow, updateWorkFlowRes] = useUpdateDocumentStatusMutation();
    const [formData, setFormData] = React.useState({
        Comment: '',
        status: '',
        ids: id
    })

    const handleSubmit = async (values) => {
        const formdata = new FormData();
        Object.entries(values).forEach(([key, value]) => {
            formdata.append(key, value);
        });

        await updateWorkFlow(formdata).unwrap();
    }


    React.useEffect(() => {
        if (updateWorkFlowRes?.isSuccess) {
            if (updateWorkFlowRes?.data?.status == 'success') {

                formikRef.current?.resetForm();
                openNotification(updateWorkFlowRes?.data?.message, 'success')
                navigate(`/projects/${projectId}/my-work`);
            } else {
                openNotification(updateWorkFlowRes?.data?.message, 'error')
            }
        }
    }, [updateWorkFlowRes?.isSuccess]);

    React.useEffect(() => {
        if (updateWorkFlowRes?.isError) {
            if (updateWorkFlowRes?.error?.data?.status == 'fail') {
                openNotification(updateWorkFlowRes?.error?.data?.message, 'error')
            } else {
                openNotification(updateWorkFlowRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [updateWorkFlowRes?.isError]);

    const validationSchema = Yup.object({
        status: Yup.string().required("Status field is required."),
        Comment: Yup.string().when("status", {
            is: (val) => val != "Approved without Comment", // or "rejected" based on your values
            then: (schema) => schema.required("Comment field is required."),
            otherwise: (schema) => schema.notRequired(),
        }),
    });

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={formData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                <form onSubmit={handleSubmit}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={12}>
                            <Autocomplete
                                options={currentStatuses}
                                getOptionLabel={(option) => option?.label}
                                value={currentStatuses.find((option) => option.label === values?.status) || null}
                                onChange={(_, newValue) => setFieldValue("status", newValue ? newValue.label : "")}
                                onBlur={() => setTouched({ ...touched, status: true })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        placeholder='Select status'
                                        name="status"
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        variant="filled"
                                    />
                                )}
                                ListboxProps={{
                                    sx: { fontSize: "13px" },
                                }}
                            />
                            {touched?.status && errors?.status &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.status}`}</FormHelperText>
                            }
                        </Grid2>
                        {values?.status != 'Approved without Comment' &&
                            <Grid2 size={12}>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Comment"
                                    name="Comment"
                                    multiline
                                    fullWidth
                                    rows={3}
                                    value={values?.Comment}
                                    onChange={handleChange}
                                    onBlur={() => setTouched({ ...touched, Comment: true })}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    variant="filled"
                                />
                                {touched?.Comment && errors?.Comment &&
                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Comment}`}</FormHelperText>
                                }
                            </Grid2>
                        }

                        <Grid2 size={12}>
                            <Button type='submit'
                                variant="contained"
                                sx={{
                                    backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    color: '#fff',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    textTransform: 'none',
                                    float: 'right'
                                }}>
                                Save
                            </Button>
                        </Grid2>
                    </Grid2>
                </form>
            )}
        </Formik>
    );
}